import { render, staticRenderFns } from "./MailBoxApp.vue?vue&type=template&id=62f7c656&"
import script from "./MailBoxApp.vue?vue&type=script&lang=js&"
export * from "./MailBoxApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62f7c656')) {
      api.createRecord('62f7c656', component.options)
    } else {
      api.reload('62f7c656', component.options)
    }
    module.hot.accept("./MailBoxApp.vue?vue&type=template&id=62f7c656&", function () {
      api.rerender('62f7c656', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/apps/mailbox/MailBoxApp.vue"
export default component.exports